import {Center} from './Component/Center';
import {Ellipsis} from './Component/Ellipsis';
import {FlexBox as FlexBoxInner} from './Component/FlexBox';

export type {FlexBoxProps} from './Component/FlexBox';

export const FlexBox = Object.assign(FlexBoxInner, {Center, Ellipsis});
